import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  fileInfo: {
    id: 'frontend-app-ora.InfoPopover.fileInfo',
    defaultMessage: 'File info',
    description: 'Popover trigger button text for file preview card',
  },
  retryButton: {
    id: 'frontend-app-ora.ResponseDisplay.FileRenderer.retryButton',
    defaultMessage: 'Retry',
    description: 'Retry button for error in file renderer',
  },
});

export default messages;
